import { Avatar, Box, Divider, Stack, Typography, useTheme } from '@mui/material'
import Summary from 'components/summary/summary'
import { useMappedTranslation } from 'hooks'
import { EllipsisStyle, IconStyle } from 'styles/theme/theme'
import { isCJK, isFamilyNameOrderFirst } from 'utils/i18n'

import IconFamily from '../assets/images/icon-family.png'

const FamilySummary = (props) => {
  const { familyGroup } = props
  const t = useMappedTranslation()
  const theme = useTheme()

  const IconProfile1 = process.env.REACT_APP_HOST + '/assets/images/profile/profile-1.svg'
  const IconProfile2 = process.env.REACT_APP_HOST + '/assets/images/profile/profile-2.svg'
  const IconProfile3 = process.env.REACT_APP_HOST + '/assets/images/profile/profile-3.svg'

  return (
    <Summary
      size={'small'}
      pageUrl={'/dashboard/family'}
      isLoading={false}
      titleIcon={IconFamily}
      title={t('family.title')}
      content={
        <Stack
          direction='row'
          divider={<Divider orientation='vertical' sx={{ height: '40px' }} />}
          spacing='0px'
          sx={{
            width: '100%',
            marginTop: { sx: '12px' },
            padding: { xs: '12px 0', md: '0' }
          }}
        >
          <Stack direction='row' alignItems='center' justifyContent='flexStart' spacing='10px' sx={{ width: '50%' }}>
            <Box>
              <Avatar sx={{ ...IconStyle }} src={familyGroup.ownerImageUrl || IconProfile1} />
            </Box>
            <Stack direction='column' sx={{ width: '100%', minWidth: 0 }}>
              <Box sx={{ width: '100%', lineHeight: '22px', md: '24px' }}>
                <Typography variant='label2' fontWeight='400' sx={{ color: theme.palette.secondary.light }}>
                  {t('family.owner')}
                </Typography>
              </Box>
              <Box sx={{ width: '100%', ...EllipsisStyle }}>
                <Typography lineHeight='22px'>
                  {isCJK(familyGroup.ownerGivenName + familyGroup.ownerFamilyName)
                    ? `${familyGroup.ownerFamilyName}${familyGroup.ownerGivenName}`
                    : isFamilyNameOrderFirst()
                    ? `${familyGroup.ownerFamilyName} ${familyGroup.ownerGivenName}`
                    : `${familyGroup.ownerGivenName} ${familyGroup.ownerFamilyName}`}
                </Typography>
              </Box>
            </Stack>
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flexStart'
            spacing='10px'
            sx={{ width: '50%', paddingLeft: '24px' }}
          >
            <Box sx={{ width: '40px', height: '40px', position: 'relative', marginLeft: '13px' }}>
              {familyGroup.memberCount === 1 && (
                <>
                  <Box component='img' src={familyGroup?.members[0]?.imageUrl || IconProfile1} sx={{ ...IconStyle }} alt='' />
                </>
              )}
              {familyGroup.memberCount === 2 && (
                <>
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[0]?.imageUrl || IconProfile1}
                    sx={{
                      width: '28px',
                      height: '28px',
                      border: `2px solid ${theme.palette.background.paper}`,
                      borderRadius: '24px',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      zIndex: 1
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[1]?.imageUrl || IconProfile2}
                    sx={{
                      width: '28px',
                      height: '28px',
                      border: `2px solid ${theme.palette.background.paper}`,
                      borderRadius: '24px',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      zIndex: 0
                    }}
                  />
                </>
              )}
              {familyGroup.memberCount === 3 && (
                <>
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[0]?.imageUrl || IconProfile1}
                    sx={{
                      width: '23px',
                      height: '23px',
                      border: `2px solid ${theme.palette.background.paper}`,
                      borderRadius: '24px',
                      position: 'absolute',
                      top: '0px',
                      left: '20px',
                      marginLeft: '-12.5px',
                      zIndex: 2
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[1]?.imageUrl || IconProfile2}
                    sx={{
                      width: '23px',
                      height: '23px',
                      border: `2px solid ${theme.palette.background.paper}`,
                      borderRadius: '24px',
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      zIndex: 1
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[2]?.imageUrl || IconProfile3}
                    sx={{
                      width: '23px',
                      height: '23px',
                      border: `2px solid ${theme.palette.background.paper}`,
                      borderRadius: '24px',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      zIndex: 0
                    }}
                  />
                </>
              )}
              {familyGroup.memberCount >= 4 && (
                <>
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[0]?.imageUrl || IconProfile1}
                    sx={{
                      width: '19px',
                      height: '19px',
                      position: 'absolute',
                      top: 0,
                      left: 0
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[1]?.imageUrl || IconProfile2}
                    sx={{
                      width: '19px',
                      height: '19px',
                      position: 'absolute',
                      top: 0,
                      right: 0
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[2]?.imageUrl || IconProfile3}
                    sx={{
                      width: '19px',
                      height: '19px',
                      position: 'absolute',
                      bottom: 0,
                      left: 0
                    }}
                  />
                  <Box
                    component='img'
                    alt=''
                    src={familyGroup?.members[3]?.imageUrl || IconProfile1}
                    sx={{
                      width: '19px',
                      height: '19px',
                      position: 'absolute',
                      bottom: 0,
                      right: 0
                    }}
                  />
                </>
              )}
            </Box>
            <Stack direction='column'>
              <Box sx={{ width: '100%', lineHeight: '22px' }}>
                <Typography variant='label2' sx={{ color: theme.palette.secondary.light }}>
                  {t('family.members')}
                </Typography>
              </Box>
              <Box sx={{ width: { xs: '80px', md: '86px' }, ...EllipsisStyle }}>
                <Typography>{familyGroup.memberCount}</Typography>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      }
    />
  )
}

export default FamilySummary
